// import React, { useState, useEffect, useContext } from "react";
// import DataTable from "react-data-table-component";
// import AuthContext from "../../contexts/AuthContext";
// import "./website-Perfomance-Details.css";

// const WebsitePerfomanceDetails = () => {
//   const { token } = useContext(AuthContext);

//   const [contacts, setContacts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10); 
//   const [totalRows, setTotalRows] = useState(0);

//   const [searchFilters, setSearchFilters] = useState({
//     email: "",
//     phoneNo: "",
//     webSiteUrl: "",
//     fromDate: "",
//     toDate: "",
//   });

//   useEffect(() => {
//     fetchContacts();
//   }, [page, pageSize, searchFilters]);

//   const fetchContacts = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_BASE_URL}/home/search`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({
//             ...searchFilters,
//             pageNo: page,
//             pageSize, // ✅ dynamic pageSize
//           }),
//         }
//       );

//       const data = await response.json();
//       setContacts(data?.data || []);
//       setTotalRows(data?.totalResult || 0);
//     } catch (error) {
//       console.error("Error fetching contacts:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//   };

//   const handleRowsPerPageChange = (newPageSize, newPage) => {
//     setPageSize(newPageSize); // ✅ KEY FIX
//     setPage(newPage);
//   };

//   const columns = [
//     {
//       name: "Phone",
//       selector: (row) => row?.userPhoneNo || "-",
//       sortable: true,
//     },
//     {
//       name: "Email",
//       selector: (row) => row?.email || "-",
//       sortable: true,
//     },
//     {
//       name: "URL",
//       cell: (row) => (
//         <div className="order-id-cell" title={row?.webUrl}>
//           {row?.webUrl}
//         </div>
//       ),
//     },
//     {
//       name: "Date",
//       selector: (row) => row?.createdDate || "-",
//       sortable: true,
//     },
//   ];

//   return (
//     <main className="website-Perfomance-Details py-3">
//       <div className="our-container">
//         <div className="inner-container">
//           <section className="website-Perfomance-Details-main-block">
//             <div className="website-Perfomance-Details-header">
//               <h1>Website Performance Details</h1>
//             </div>
//           </section>

//           <div className="website-Perfomance-Details-body">
//             <DataTable
//               columns={columns}
//               data={contacts}
//               progressPending={loading}
//               pagination
//               paginationServer
//               paginationTotalRows={totalRows}
//               paginationPerPage={pageSize}
//               onChangePage={handlePageChange}
//               onChangeRowsPerPage={handleRowsPerPageChange} // ✅ FIX
//               highlightOnHover
//             />
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// };

// export default WebsitePerfomanceDetails;


import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import AuthContext from "../../contexts/AuthContext";
import AdminLayout from "../../layouts"; // Wrap with layout for consistency
import "./website-Perfomance-Details.css";

const WebsitePerfomanceDetails = () => {
  const { token, triggerSessionExpired } = useContext(AuthContext);

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  // Temporary state for the input fields
  const [filters, setFilters] = useState({
    email: "",
    phoneNo: "",
    webSiteUrl: "",
    fromDate: "",
    toDate: "",
  });

  // Active state that triggers the actual API call
  const [activeSearch, setActiveSearch] = useState({});

  useEffect(() => {
    fetchContacts();
  }, [page, pageSize, activeSearch]);

  const fetchContacts = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/home/search`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...activeSearch,
            pageNo: page,
            pageSize,
          }),
        }
      );

      if (response.status === 401 || response.status === 403) {
        triggerSessionExpired();
        return;
      }

      const data = await response.json();
      setContacts(data?.data || []);
      setTotalRows(data?.totalResult || 0);
    } catch (error) {
      console.error("Error fetching SEO contacts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = () => {
    setPage(1); // Reset to first page
    setActiveSearch(filters);
  };

  const handleClear = () => {
    const emptyFilters = {
      email: "",
      phoneNo: "",
      webSiteUrl: "",
      fromDate: "",
      toDate: "",
    };
    setFilters(emptyFilters);
    setActiveSearch(emptyFilters);
  };

  // Themes the table to match the panel's premium redesign (brand-gradient
  // header row, softer hover tint) without touching react-data-table-component's markup.
  const tableCustomStyles = {
    headRow: {
      style: {
        background: "var(--admin-bg)",
        minHeight: "52px",
        borderBottom: "1px solid var(--admin-border)",
      },
    },
    headCells: {
      style: {
        color: "var(--admin-text-primary)",
        fontSize: "13px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.03em",
      },
    },
    rows: {
      style: {
        minHeight: "54px",
        fontSize: "14px",
        color: "#29282b",
      },
      highlightOnHoverStyle: {
        backgroundColor: "rgba(0, 180, 255, 0.08)",
        borderBottomColor: "#e4e7ee",
        outline: "none",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #eef0f5",
      },
    },
  };

  const columns = [
    {
      name: "Phone",
      selector: (row) => row?.userPhoneNo || "-",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email || "-",
      sortable: true,
    },
    {
      name: "URL",
      cell: (row) => (
        <div className="order-id-cell" title={row?.webUrl}>
          {row?.webUrl}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row?.createdDate || "-",
      sortable: true,
    },
  ];

  return (
    <AdminLayout>
      <div className="website-Perfomance-Details">
        <div className="page-banner">
          <div className="page-banner-text">
            <span className="page-banner-tag">SEO</span>
            <h1 className="page-banner-title">Website Performance Details</h1>
          </div>
          <div className="page-banner-badge">
            <span className="page-banner-badge-label">Total</span>
            <span className="page-banner-badge-value">{totalRows}</span>
          </div>
        </div>

        {/* --- SEARCH FILTER SECTION --- */}
        <div className="search-filter-card">
          <div className="search-grid">
            <div className="filter-group">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                placeholder="Enter Email"
                value={filters.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>Phone No:</label>
              <input
                type="text"
                name="phoneNo"
                placeholder="Enter Phone No"
                value={filters.phoneNo}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>Website URL:</label>
              <input
                type="text"
                name="webSiteUrl"
                placeholder="Enter URL"
                value={filters.webSiteUrl}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>From Date:</label>
              <input
                type="date"
                name="fromDate"
                value={filters.fromDate}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>To Date:</label>
              <input
                type="date"
                name="toDate"
                value={filters.toDate}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="search-actions">
            <button className="btn-search" onClick={handleSearch}>
              Search
            </button>
            <button className="btn-clear" onClick={handleClear}>
              Clear
            </button>
          </div>
        </div>

        {/* --- DATA TABLE SECTION --- */}
        <div className="website-Perfomance-Details-body">
          <DataTable
            columns={columns}
            data={contacts}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={pageSize}
            onChangePage={(p) => setPage(p)}
            onChangeRowsPerPage={(ps, p) => {
              setPageSize(ps);
              setPage(p);
            }}
            highlightOnHover
            customStyles={tableCustomStyles}
          />
        </div>
      </div>
    </AdminLayout>
  );
};

export default WebsitePerfomanceDetails;